import React, { Fragment } from 'react'
import styled from 'styled-components'
import { isEmpty, pathOr, path } from 'ramda'
import FacilityLocation from '../common/FacilityLocation'
import LocationInfo from '../common/FacilityLocation/LocationInfo'
import Overview from './Overview'

const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`

export const viewConfig = (hasOverview, primaryFacility) => ({
  locationHeight: hasOverview ? '550' : '300',
  flexDirection: hasOverview ? 'column' : 'row',
  flexBasis: '55',
  order: hasOverview,
  title: primaryFacility ? 'FACILITY' : 'SECTION',
  infoFontSize: hasOverview ? 12 : 14
})

export const makeSectionShape = data => ({
  ...pathOr({}, ['address'], data),
  geolocation: pathOr(null, ['primaryFacility', 'geolocation'], data),
  phoneNumber: pathOr(null, ['primaryFacility', 'phoneNumber'], data)
})

export const makeFacilityShape = data => ({
  ...data,
  ...data.address
})

export default ({ hit = {} }) => {
  const { primaryFacility } = hit
  const hasOverview = !isEmpty(pathOr('', ['overview'], hit))
  const facilityOrSection = primaryFacility ? makeFacilityShape(primaryFacility) : makeSectionShape(hit.section)
  return (
    <Fragment>
      <FlexWrapper>
        <FacilityLocation
          hit={hit}
          geoloc={facilityOrSection.geolocation}
          viewConfig={viewConfig(hasOverview, hit.primaryFacility)}
          LocationInfo={LocationInfo}
          addressInfo={facilityOrSection}
          sectionName={path(['section', 'name'], hit)}
        />
        {hasOverview && <Overview {...{ hit }} />}
      </FlexWrapper>
    </Fragment>
  )
}
